module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.52dd7ddf.woff";